import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Laptop"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 18.0037H4.5C3.67192 18.0028 3.00083 17.3317 3 16.5037V6.00366C3.00083 5.17558 3.67192 4.50449 4.5 4.50366H19.5C20.3281 4.50449 20.9992 5.17558 21 6.00366V16.5037C20.9988 17.3316 20.3279 18.0024 19.5 18.0037ZM4.5 6.00366V16.5037H19.5V6.00366H4.5ZM1.5 19.5037H22.5V21.0037H1.5V19.5037Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Laptop.vue"]]);
